


























import FieldModel from '@/UI/Shared/Mixins/FieldModel'
import mixins from 'vue-typed-mixins'

const ONLY_NUMBER_REGEX = /([^0-9,])+/g
const FORMAT_REGEX = /^[0-9]+?,[0-9]{2}$/

export default mixins(FieldModel).extend({
  name: 'FormattedNumberInput',
  props: {
    label: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      status: '',
      errorMessage: ''
    }
  },
  computed: {
    calculatedClass (): string {
      return this.label === '' ? 'col-xs-12' : 'col-sm-9'
    },
    iconClass (): string {
      if (this.status === 'success') {
        return 'glyphicon-ok'
      }
      if (this.status === 'danger') {
        return 'glyphicon-remove'
      }
      return ''
    },
    statusMessage (): string {
      if (this.status === '') {
        return ''
      }
      return this.$t('shared.input.message.' + this.status).toString()
    },
    statusClass (): string {
      if (this.status === 'success') {
        return 'has-success has-feedback'
      }
      if (this.status === 'danger') {
        return 'has-error has-feedback'
      }
      return ''
    }
  },
  watch: {
    currentValue (newValue: string) {
      this.status = FORMAT_REGEX.test(newValue)
        ? 'success'
        : 'danger'
    },
    status (newValue: string, oldValue: string) {
      if (newValue !== oldValue) {
        this.$emit('valid-input', newValue === 'success')
      }
    }
  },
  methods: {
    formatNumber () {
      const value = this.currentValue + ''
      const parsedValue = value.replace(ONLY_NUMBER_REGEX, '')
      this.currentValue = parsedValue
      this.emitValue(parsedValue)
      this.$emit('valid-input', this.status === 'success')
    }
  }
})
